import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Badge"
}
const _hoisted_2 = { class: "RefineContentOptionsList" }
const _hoisted_3 = { class: "controlLabel" }
const _hoisted_4 = { class: "rangeContainer" }
const _hoisted_5 = { class: "formControl" }
const _hoisted_6 = { class: "SCTextInput" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "SCTextInput" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "sliderControl" }
const _hoisted_11 = ["step", "max"]
const _hoisted_12 = ["step", "max"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tracking = _resolveComponent("Tracking")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["TuitionFeeFilterWrapper", { 'is-collapsed': _ctx.collapsed }])
  }, [
    _createElementVNode("header", {
      class: "RefineSectionHeading",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFilter()))
    }, [
      _cache[10] || (_cache[10] = _createElementVNode("i", { class: "lnr-bag-coins FilterIcon" }, null, -1 /* HOISTED */)),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "Title" }, "Tuition Fee", -1 /* HOISTED */)),
      (_ctx.filterHintCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.filterHintCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIcon", [_ctx.collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']])
      }, null, 2 /* CLASS */)
    ]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, [
          _cache[12] || (_cache[12] = _createElementVNode("b", null, "Annual tuition fee ", -1 /* HOISTED */)),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeCurrencyClicked && _ctx.changeCurrencyClicked(...args))),
            class: "Currency"
          }, _toDisplayString(_ctx.userCurrency), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("input", {
              ref: "fromInputRef",
              value: _ctx.fromSelectedFormatted,
              onOnfocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateFromInputValue && _ctx.updateFromInputValue(...args))),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateFromInputValue && _ctx.updateFromInputValue(...args))),
              inputmode: "numeric"
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7),
            (_ctx.trackingDataForFromInput)
              ? (_openBlock(), _createBlock(_component_Tracking, {
                  key: 0,
                  data: _ctx.trackingDataForFromInput
                }, null, 8 /* PROPS */, ["data"]))
              : _createCommentVNode("v-if", true),
            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Min", -1 /* HOISTED */))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("input", {
              ref: "toInputRef",
              value: _ctx.toSelectedFormatted,
              onOnfocusout: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateToInputValue && _ctx.updateToInputValue(...args))),
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateToInputValue && _ctx.updateToInputValue(...args))),
              inputmode: "numeric"
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9),
            (_ctx.trackingDataForToInput)
              ? (_openBlock(), _createBlock(_component_Tracking, {
                  key: 0,
                  data: _ctx.trackingDataForToInput
                }, null, 8 /* PROPS */, ["data"]))
              : _createCommentVNode("v-if", true),
            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Max", -1 /* HOISTED */))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            ref: "fromSliderRef",
            class: "fromSlider slider",
            step: _ctx.sliderStepSize,
            type: "range",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fromSelected) = $event)),
            min: "0",
            max: _ctx.maxValue,
            onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateFromInputValue && _ctx.updateFromInputValue(...args)))
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_11), [
            [_vModelText, _ctx.fromSelected]
          ]),
          (_ctx.trackingDataForFromSlider)
            ? (_openBlock(), _createBlock(_component_Tracking, {
                key: 0,
                data: _ctx.trackingDataForFromSlider
              }, null, 8 /* PROPS */, ["data"]))
            : _createCommentVNode("v-if", true),
          _withDirectives(_createElementVNode("input", {
            ref: "toSliderRef",
            class: "toSlider slider",
            step: _ctx.sliderStepSize,
            type: "range",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.toSelected) = $event)),
            min: "0",
            max: _ctx.maxValue,
            onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateToInputValue && _ctx.updateToInputValue(...args)))
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12), [
            [_vModelText, _ctx.toSelected]
          ]),
          (_ctx.trackingDataForToSlider)
            ? (_openBlock(), _createBlock(_component_Tracking, {
                key: 1,
                data: _ctx.trackingDataForToSlider
              }, null, 8 /* PROPS */, ["data"]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ], 2 /* CLASS */))
}